import Component from "@glimmer/component";
import InputTip from "discourse/components/input-tip";
import ConditionalCharCounter from "./conditional-char-counter";

export default class ValidationTip extends Component {
  get shouldShowValidationTip() {
    return this.args.validation || this.args.maxLength;
  }

  <template>
    {{#if this.shouldShowValidationTip}}
      <div class="validation-tip">
        {{#if @validation.loading}}
          <div class="tip" ...attributes>
            <span class="spinner"></span>
            <span class="tip-content">{{@validation.reason}}</span>
          </div>
        {{else}}
          <InputTip @validation={{@validation}} />
        {{/if}}
        <ConditionalCharCounter @value={{@value}} @max={{@maxLength}} />
      </div>
    {{/if}}
  </template>
}
